import { Box, LinearProgress, LinearProgressProps, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';

const HoverLoader = ({ text }: any) => {
    return (
        <Modal
            open={true}
        >
            <Box sx={{ alignItems: 'center', justifyContent: 'center', display: 'flex', height: '100%' }} >
                <Box sx={{ p: 3, gap: 3, textAlign: 'center', background: '#f5f5f5', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <CircularProgress color="primary" />
                    {text && <Typography color="primary">{text}</Typography>}
                </Box>
            </Box>
        </Modal>
    )
}

function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary">{`${Math.round(
                    props.value,
                )}%`}
                </Typography>
            </Box>
        </Box>
    );
}

export { HoverLoader, LinearProgressWithLabel };